import $ from 'jquery';
import React from 'react';
import { SettingOutlined } from '@ant-design/icons';
import ResizeBtn from '../GraphHeader/ResizeBtn';
import ShapeBtn from '../GraphHeader/ShapeBtn';
import { Row } from 'antd';

const PanningConfig = ({ cy }) => {
  const fadeToggle = () => {
    console.log('panning config: fadeToggle');
    $('#panning-options').fadeToggle(1000);
  };

  const enablePanning = (conf) => {
    // debug-console.log('****** Set enable panning: ' + conf);
    cy.panningEnabled(conf);
  };

  return (
    <Row id="panning-config" className="panning-cls">
      <div className="icon-wrapper" onClick={fadeToggle}>
        <SettingOutlined about="Chế độ xem" id="panning-config-icon" />
      </div>

      <div id="panning-options" style={{ display: 'none' }}>
        <div>
          <input
            type="radio"
            id="isPanningEnabled"
            name="isPanning"
            value="true"
            onClick={() => enablePanning(true)}
            defaultChecked
          />
          <label htmlFor="isPanningEnabled">Nhấn chuột và kéo</label>
        </div>

        <div>
          <input
            type="radio"
            id="isPanningDisabled"
            name="isPanning"
            value="false"
            onClick={() => enablePanning(false)}
          />
          <label htmlFor="isPanningDisabled">Vuốt màn hình</label>
        </div>
        <ResizeBtn />
        <ShapeBtn />
      </div>
    </Row>
  );
};

export default PanningConfig;
